import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useStats } from '../contexts/StatsContext';
import { CheckCircle2, Star } from 'lucide-react';

const QuickInfo = () => {
  const { t, language } = useLanguage();
  const { googleReviews } = useStats();

  const googleReviewsUrl = "https://www.google.com/search?q=erste+hilfe+fokus+d%C3%BCsseldorf&oq=erste+hilfe+fokus";

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        {/* Google Rating Badge - Clickable */}
        <div className="flex justify-center mb-8">
          <a 
            href={googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-neutral-50 px-5 py-3 rounded-full border border-neutral-200 shadow-sm hover:shadow-md hover:border-neutral-300 transition-all cursor-pointer"
          >
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-base font-semibold text-neutral-700">
              {language === 'de' ? `Über ${googleReviews}+ Top-Bewertungen auf` : `Over ${googleReviews}+ Top Reviews on`}
            </span>
            <img
              src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"
              alt="Google"
              className="h-5 w-auto"
            />
          </a>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center text-neutral-900 mb-12">
          {t('quickInfo.title')}
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {t('quickInfo.items').map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-4 bg-neutral-50 p-4 rounded-xl border border-neutral-100 card-hover opacity-0 animate-fadeIn"
              style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'forwards' }}
            >
              <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <CheckCircle2 className="w-5 h-5 text-red-600" />
              </div>
              <span className="text-neutral-700 font-medium text-sm">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickInfo;
